export default {
  badge: 'Maintenance',
  title: 'Opération de maintenance en cours',
  text: 'Une opération de maintenance est en cours, l\'accès à votre espace client est désactivé temporairement. Nous vous invitons à réessayer ultérieurement, et vous prions de bien vouloir nous excuser pour la gêne occasionnée.',
  hint: 'Si la page ne se met pas à jour automatiquement, vous pouvez réessayer dans quelques minutes.',
  retry: 'Réessayer',
};
